'use strict';
module.exports = function shouldRequestWatermark(envelopes) {
	const cutOffHours = 24,
		minNumChanges = 100,
		cutoff = Date.now() - (cutOffHours * 60 * 60 * 1000),
		firstHeader = envelopes && envelopes.length  && envelopes[0].header;
	// console.log('cutoff', cutoff, 'firstHeader.ts', firstHeader.ts);//eslint-disable-line
	if (firstHeader && firstHeader.ts < cutoff && envelopes.length >= minNumChanges) {
		return true;
	}
	return false;
};
